// Add this to assets/quick-add-customizer

class QuickAddCustomizer {
  constructor() {
    this.bundleRedirectUrl = '/pages/bundle-page'; // Change this to your target page URL
    this.bundleButtonText = 'Build Your Bundle'; // Change this to your desired button text
    this.init();
    
    // Handle Shopify's section rendering
    document.addEventListener('shopify:section:load', () => this.init());
  }

  init() {
    // Handle standard quick add buttons
    document.addEventListener('click', (event) => {
      const button = event.target.closest('.quick-add__submit');
      if (!button) return;

      const cardWrapper = button.closest('.card-wrapper');
      if (!cardWrapper) return;

      const tags = cardWrapper.dataset.productTags?.split(',') || [];
      if (tags.includes('bundles')) {
        event.preventDefault();
        event.stopPropagation();
        window.location.href = this.bundleRedirectUrl;
      }
    });

    // Handle variant selector modal buttons
    document.addEventListener('click', (event) => {
      const button = event.target.closest('modal-opener[data-modal^="#QuickAdd-"] button');
      if (!button) return;

      const cardWrapper = button.closest('.card-wrapper');
      if (!cardWrapper) return;

      const tags = cardWrapper.dataset.productTags?.split(',') || [];
      if (tags.includes('bundles')) {
        event.preventDefault();
        event.stopPropagation();
        window.location.href = this.bundleRedirectUrl;
      }
    });

    // Update button text for bundle products
    this.updateBundleButtonText();
  }

  updateBundleButtonText() {
    const productCards = document.querySelectorAll('.card-wrapper');
    productCards.forEach(card => {
      const tags = card.dataset.productTags?.split(',') || [];
      if (tags.includes('bundles')) {
        const quickAddButton = card.querySelector('.quick-add__submit');
        if (quickAddButton) {
          const buttonSpan = quickAddButton.querySelector('span');
          if (buttonSpan) {
            buttonSpan.textContent = this.bundleButtonText;
          }
        }
      }
    });
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new QuickAddCustomizer();
  });
} else {
  new QuickAddCustomizer();
}